import dayjs from "dayjs";
import { useDonations } from "../../store/useDonations";

export const DonationsTable = () => {
  /** Hooks */
  const { allDonations } = useDonations();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="hidden sm:table-cell px-6 py-3">
              Community
            </th>
            <th scope="col" className="px-6 py-3">
              Full name
            </th>
            <th scope="col" className="hidden sm:table-cell px-6 py-3">
              Date
            </th>
            <th scope="col" className="px-6 py-3 text-right">
              Amount
            </th>
          </tr>
        </thead>
        <tbody>
          {/* @ts-ignore */}
          {allDonations?.data.length
            ? // @ts-ignore
              allDonations?.data.map((item) => (
                <tr
                  key={item?._id}
                  className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
                >
                  <td className="hidden sm:table-cell px-6 py-4 whitespace-nowrap">
                    {/* @ts-ignore */}
                    {item.community?.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {/* @ts-ignore */}
                    {item.user?.first_name} {item.user?.last_name}
                  </td>
                  <td className="hidden sm:table-cell px-6 py-4 whitespace-nowrap">
                    {/* @ts-ignore */}
                    {dayjs(item?.createdAt).format("DD/MM/YYYY")}
                  </td>
                  <td className="px-6 py-4 flex items-center justify-end cursor-pointer">
                    {Number(item?.amount ? item?.amount / 100 : 0)?.toFixed(2)}€
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
